import React from "react"
import Logo from "../../../images/arden-university.png"
import calendarStyles from "./calendar.module.css"
import DateIcon from "../../../images/arden-icon-solid-calendar-primary.svg"
import clockIcon from "../../../images/arden-icon-solid-time-primary.svg"

const Calendar = ({ BackgroundImage, webinarDate, webinarTime, display }) => (
  <div class={`full-width ${calendarStyles.calendar} white`} style={display}>
    <div class="page-wrapper">
      <span>
        <img className={calendarStyles.calendarimg} src={DateIcon} />
        <p className={calendarStyles.date}>
          Date:
          <br />
          <span>{webinarDate}</span>
        </p>
      </span>
      <span>
        <img className={calendarStyles.calendarimg} src={clockIcon} />
        <p className={calendarStyles.date}>
          Time:
          <br />
          <span>{webinarTime}</span>
        </p>
      </span>
    </div>
  </div>
)

export default Calendar
